const MobileHyfye = () => { 
  return (
    <section id="mobileapp" className="bg_light_dark bg-animated bg-9" data-z-index="1" data-parallax="scroll" data-image-src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/mobilephone.jpg">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Side - Text */}
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="title_default_light title_border text_md_center">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Hyfye Mobile & Desktop Experience</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Seamlessly connect with the Hyfye ecosystem across all your devices. The upcoming Hyfye App empower users to manage their HYE tokens, access Web3 tools, and stay up to date with platform developments.
              </p>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Whether you're managing liquidity, monitoring project metrics, or interacting with Hyfye-powered dApps, the app offers a secure and intuitive experience—anytime, anywhere.
              </p>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Built for both real-world and digital integration, Hyfye supports mobile and desktop environments. Launching soon on iOS, Android, and Desktop.
              </p>
            </div>

            {/* Buttons */}
            <div className="btn_group text_md_center animation" data-animation="fadeInUp" data-animation-delay="0.1s"> 
              <a href="#" className="btn btn-default disabled"><em className="ion-social-android"></em>Coming Soon</a> 
              <a href="#" className="btn btn-default disabled"><em className="ion-social-apple"></em>Coming Soon</a> 
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="col-lg-5 col-md-12 col-sm-12">
            <div className="res_md_mt_50 res_sm_mt_30 text-center animation" data-animation="fadeInRight" data-animation-delay="0.1s"> 
            
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MobileHyfye;
